
// // import newsImg1 from "./../../../assets/images/gallery-1.png"; // Adjust the path as necessary
// // import newsImgsm from "./../../../assets/images/gallery-2.png"; // Adjust the path as necessary

// // function LatestNews() {
// //   return (
// //     <>
// //     <div className="service-title text-green-38B652 font-700 mb-3">LATEST <span className="text-orange-ef3e33 font-400">NEWS</span>
// //               </div>
// //               {/* <div className="service-box mb-5 mb-sm-4">
// //                 The South African Maritime Safety Authority (“SAMSA”) was established in  terms of SAMSA Act, 1998<br/>
// //                 (“the Act”) as a juristic person.<br/>
// // 	Its objectives are―</div> */}

// //               <div className="row g-3 g-sm-4">
// //                 <div className="col-lg-8">
           
// //                   <div className="row g-3 g-sm-4 g-md-5">
// //                     <div className="col-12">
// //                         <div className=" w-100">
// //                             <div className="card-img mb-3 position-relative">
// //                                 <div className="badge d-flex flex-column bg-green-38B652 py-2 px-3 rounded-2 position-absolute font-14 text-white align-items-start top-10 left-10"><span className="mb-1 font-400 mt-1">20</span> <span className="mb-1">Dec</span></div>
// //                                 <img src={newsImg1} alt="Profile" className="img-fluid w-100" />                            
// //                             </div>
// //                             <div className="row g-3 align-items-center">
// //                             <div className="col-auto d-flex align-items-center"><i className="bi bi-person me-2"></i> <span className="font-14 font-600 text-lite-gray">Mehedii.H</span></div>
// //                             <div className="col-auto d-flex align-items-center"><i className="bi bi-gear me-2"></i> <span className="font-14 font-600 text-lite-gray">Comments (03)</span></div>
// //                             </div>
// //                             <h4 className="title text-green-38B652 mt-3 mb-2 font-17 font-600 text-wrap">Min 02-25 All Samsa Personnel, Ship Agents, Port Authorities, Ship Owners, Ship Managers, Seafarers And Other Interested ....</h4>
// //                             <p className="font-17 text-primary-color">Ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo  consequat. Duis aute irure dolor in reprehenderit in voluptate velit  esse cillum dolore eu ,  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea co,  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea co,  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea co</p>                            
// //                         </div>
// //                     </div>

// //                     <div className="col-12">
// //                         <div className=" w-100">
// //                             <div className="quote-title mb-3 text-green-38B652 d-flex">
// //                                 <div className="flex-1">
// //                                     Access to Seafaring Careers <span className="font-600">Survey : 2025</span>
// //                                 </div>
// //                                 <i className="icon-quote"></i>
// //                             </div>
// //                             <div className="row g-3 align-items-center mb-4">
// //                                 <div className="col-auto">
// //                                     <button className="btn-green-38B652 rounded-2 font-700">Take it now</button>
// //                                 </div>
// //                                 <div className="col-auto text-orange-ef3e33">Recommended By SAMSA</div>
                            
// //                             </div>
// //                             <div className="card-img mb-3 position-relative">
                                
// //                                 <div className="row g-3">
// //                                     <div className="col-6">
// //                                         <img src={newsImgsm} alt="Profile" className="img-fluid w-100" />
// //                                     </div>
// //                                     <div className="col-6">
// //                                         <img src={newsImgsm} alt="Profile" className="img-fluid w-100" />
// //                                     </div>
// //                                 </div>
                                                            
// //                             </div>
// //                             <div className="row g-3 align-items-center">
// //                             <div className="col-auto d-flex align-items-center"><i className="bi bi-person me-2"></i> <span className="font-14 font-600 text-lite-gray">Mehedii.H</span></div>
// //                             <div className="col-auto d-flex align-items-center"><i className="bi bi-gear me-2"></i> <span className="font-14 font-600 text-lite-gray">Comments (03)</span></div>
// //                             </div>
// //                             <h4 className="title text-green-38B652 mt-3 mb-2 font-17 font-600 text-wrap">Min 02-25 All Samsa Personnel, Ship Agents, Port Authorities, Ship Owners, Ship Managers, Seafarers And Other Interested ....</h4>
// //                             <p className="font-17 text-primary-color">Ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo  consequat. Duis aute irure dolor in reprehenderit in voluptate velit  esse cillum dolore eu ,  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea co,  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea co,  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea co</p>                            
// //                         </div>
// //                     </div>
// //                   </div>
             
                  
// //                 </div>
// //                 <div className="col-lg-4">
// //                   <div className="row g-3 g-sm-4 g-md-4">
// //                         <div className="col-12">
// //                             <div className="bg-gray-d9 p-4">
// //                                 <h3 className="sideline-title font-23 font-700 mb-3">Search here</h3>
// //                                 <div className="input-group"><input type="text" className="form-control height-45 rounded-0 font-17" placeholder="search here....." />  </div>
// //                             </div>
// //                         </div>
// //                         <div className="col-12">
// //                             <div className="bg-gray-d9 p-4">
// //                                 <h3 className="sideline-title font-23 font-700 mb-3">Recent News</h3>
// //                                 <div className="row g-3 g-sm-4">
// //                                     <div className="col-md-12 col-sm-6">
// //                                         <div className="row g-3">
// //                                             <div className="col-auto">
// //                                                 <div className="bg-primary-green ratio-80" ></div>
// //                                             </div>
// //                                             <div className="col text-primary-color">
// //                                                 <h4 className="font-17 font-700 mb-1 d-flex"><i className="icon-calender me-1"></i><span className="font-700 mt-1">Jan 23, 2023</span></h4>
// //                                                 <p className="font-17 mb-0 lineHeight-20" >Wreck-removal-of-grounded.</p>    
// //                                             </div>
// //                                         </div>
// //                                     </div>
// //                                     <div className="col-md-12 col-sm-6">
// //                                         <div className="row g-3">
// //                                             <div className="col-auto">
// //                                                 <div className="bg-primary-green ratio-80" ></div>
// //                                             </div>
// //                                             <div className="col text-primary-color">
// //                                                 <h4 className="font-17 font-700 mb-1 d-flex"><i className="icon-calender me-1"></i><span className="font-700 mt-1">Jan 23, 2023</span></h4>
// //                                                 <p className="font-17 mb-0 lineHeight-20" >Wreck-removal-of-grounded.</p>    
// //                                             </div>
// //                                         </div>
// //                                     </div>
// //                                     <div className="col-md-12 col-sm-6">
// //                                         <div className="row g-3">
// //                                             <div className="col-auto">
// //                                                 <div className="bg-primary-green ratio-80" ></div>
// //                                             </div>
// //                                             <div className="col text-primary-color">
// //                                                 <h4 className="font-17 font-700 mb-1 d-flex"><i className="icon-calender me-1"></i><span className="font-700 mt-1">Jan 23, 2023</span></h4>
// //                                                 <p className="font-17 mb-0 lineHeight-20" >Wreck-removal-of-grounded.</p>    
// //                                             </div>
// //                                         </div>
// //                                     </div>
// //                                     <div className="col-md-12 col-sm-6">
// //                                         <div className="row g-3">
// //                                             <div className="col-auto">
// //                                                 <div className="bg-primary-green ratio-80" ></div>
// //                                             </div>
// //                                             <div className="col text-primary-color">
// //                                                 <h4 className="font-17 font-700 mb-1 d-flex"><i className="icon-calender me-1"></i><span className="font-700 mt-1">Jan 23, 2023</span></h4>
// //                                                 <p className="font-17 mb-0 lineHeight-20" >Wreck-removal-of-grounded.</p>    
// //                                             </div>
// //                                         </div>
// //                                     </div>

// //                                     <div className="col-12">
// //                                         <a href="javascript:;" className="font-17 font-700 text-primary-color text-decoration-none">1 - 13 <i className="bi bi-chevron-right"></i></a>
// //                                     </div>
// //                                 </div>
// //                             </div>
// //                         </div>
// //                   </div>
// //                 </div>
// //               </div>
// //     </>
// //   )
// // }

// // export default LatestNews


// import { useEffect, useState } from "react";

// function LatestNews() {
//   const [posts, setPosts] = useState([]);
//   const [selectedPost, setSelectedPost] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     async function fetchPosts() {
//       try {
//         const res = await fetch(
//           "https://blog.samsa.org.za/wp-json/wp/v2/posts?per_page=10&_embed"
//         );
//         const data = await res.json();
//         setPosts(data);
//         setSelectedPost(data[0]);
//       } catch (err) {
//         console.error("Failed to fetch news:", err);
//       }
//     }
//     fetchPosts();
//   }, []);

//   // Search in both title and content
//   const filteredPosts = posts.filter((post) => {
//     const title = post.title.rendered.toLowerCase();
//     const content = post.content.rendered.toLowerCase();
//     return (
//       title.includes(searchTerm.toLowerCase()) ||
//       content.includes(searchTerm.toLowerCase())
//     );
//   });

//   const handlePostClick = (post) => {
//     setSelectedPost(post);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   return (
//     <>
//       <div className="service-title text-green-38B652 font-700 mb-3">
//         LATEST <span className="text-orange-ef3e33 font-400">NEWS</span>
//       </div>

//       <div className="row g-3 g-sm-4">
//         {/* Main Post */}
//         <div className="col-lg-8">
//           {selectedPost ? (
//             <div>
//               {/* Featured Image */}
//               <div className="card-img mb-3 position-relative">
//                 {selectedPost._embedded?.["wp:featuredmedia"]?.[0]?.source_url && (
//                   <img
//                     src={selectedPost._embedded["wp:featuredmedia"][0].source_url}
//                     alt={selectedPost.title.rendered}
//                     className="img-fluid w-100"
//                   />
//                 )}
//               </div>

//               {/* Meta Info */}
//               <div className="row g-3 align-items-center">
//                 <div className="col-auto d-flex align-items-center">
//                   <i className="bi bi-person me-2"></i>
//                   <span className="font-14 font-600 text-lite-gray">
//                     SAMSA Author
//                   </span>
//                 </div>
//                 <div className="col-auto d-flex align-items-center">
//                   <i className="bi bi-gear me-2"></i>
//                   <span className="font-14 font-600 text-lite-gray">
//                     No Comments
//                   </span>
//                 </div>
//               </div>

//               {/* Title */}
//               <h4
//                 className="title text-green-38B652 mt-3 mb-2 font-17 font-600 text-wrap"
//                 dangerouslySetInnerHTML={{
//                   __html: selectedPost.title.rendered,
//                 }}
//               />

//               {/* Content */}
//               <div
//                 className="font-17 text-primary-color"
//                 dangerouslySetInnerHTML={{
//                   __html: selectedPost.content.rendered,
//                 }}
//               />
//             </div>
//           ) : (
//             <div>Loading latest news...</div>
//           )}
//         </div>

//         {/* Sidebar */}
//         <div className="col-lg-4">
//           {/* Search */}
//           <div className="bg-gray-d9 p-4 mb-4">
//             <h3 className="sideline-title font-23 font-700 mb-3">Search here</h3>
//             <input
//               type="text"
//               className="form-control height-45 font-17"
//               placeholder="search here..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </div>

//           {/* Recent News */}
//           <div className="bg-gray-d9 p-4">
//             <h3 className="sideline-title font-23 font-700 mb-3">Recent News</h3>
//             <div className="row g-3 g-sm-4">
//               {filteredPosts.map((post) => (
//                 <div
//                   className="col-md-12 col-sm-6"
//                   key={post.id}
//                   onClick={() => handlePostClick(post)}
//                   style={{ cursor: "pointer" }}
//                 >
//                   <div className="row g-3">
//                     <div className="col-auto">
//                       {post._embedded?.["wp:featuredmedia"]?.[0]?.source_url ? (
//                         <img
//                           src={post._embedded["wp:featuredmedia"][0].source_url}
//                           alt={post.title.rendered}
//                           className="img-fluid"
//                           style={{
//                             width: "80px",
//                             height: "80px",
//                             objectFit: "cover",
//                           }}
//                         />
//                       ) : (
//                         <div className="bg-primary-green ratio-80"></div>
//                       )}
//                     </div>
//                     <div className="col text-primary-color">
//                       <h4 className="font-17 font-700 mb-1 d-flex align-items-center">
//                         <i className="icon-calender me-1"></i>
//                         <span className="font-700 mt-1">
//                           {new Date(post.date).toLocaleDateString()}
//                         </span>
//                       </h4>
//                       <p
//                         className="font-17 mb-0 lineHeight-20"
//                         dangerouslySetInnerHTML={{
//                           __html: post.title.rendered,
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               ))}
//               {filteredPosts.length === 0 && (
//                 <p className="font-17 text-center text-muted">
//                   No results found
//                 </p>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default LatestNews;


import { useEffect, useState } from "react";

function LatestNews() {
  const [posts, setPosts] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [authors, setAuthors] = useState({});

  useEffect(() => {
    async function fetchPosts() {
      try {
        const res = await fetch(
          "https://blog.samsa.org.za/wp-json/wp/v2/posts?per_page=10&_embed"
        );
        const data = await res.json();
        setPosts(data);
        setSelectedPost(data[0]);

        // Fetch authors
        const authorIds = [...new Set(data.map((p) => p.author))];
        const authorPromises = authorIds.map((id) =>
          fetch(`https://blog.samsa.org.za/wp-json/wp/v2/users/${id}`).then((r) =>
            r.json()
          )
        );
        const authorData = await Promise.all(authorPromises);
        const authorMap = {};
        authorData.forEach((a) => {
          authorMap[a.id] = a.name;
        });
        setAuthors(authorMap);
      } catch (err) {
        console.error("Failed to fetch news:", err);
      }
    }
    fetchPosts();
  }, []);

  // Get main image (featured or first content image)
  const getMainImage = (post) => {
    let imageUrl =
      post._embedded?.["wp:featuredmedia"]?.[0]?.source_url || null;
    if (!imageUrl) {
      const match = post.content.rendered.match(/<img[^>]+src="([^">]+)"/);
      if (match && match[1]) {
        imageUrl = match[1];
      }
    }
    return imageUrl;
  };

  // Get a short preview (strip images + limit length)
  const getPreviewContent = (htmlContent) => {
    const textOnly = htmlContent
      .replace(/<img[^>]*>/g, "") // remove images
      .replace(/<[^>]+>/g, "") // remove HTML tags
      .trim();
    return textOnly.length > 250
      ? textOnly.substring(0, 250) + "..."
      : textOnly;
  };

  // Search in title + content
  const filteredPosts = posts.filter((post) => {
    const title = post.title.rendered.toLowerCase();
    const content = post.content.rendered.toLowerCase();
    return (
      title.includes(searchTerm.toLowerCase()) ||
      content.includes(searchTerm.toLowerCase())
    );
  });

  // Replace content without scrolling to top
  const handlePostClick = (post) => {
    setSelectedPost(post);
  };

  return (
    <>
      <div className="service-title text-green-38B652 font-700 mb-3">
        LATEST <span className="text-orange-ef3e33 font-400">NEWS</span>
      </div>

      <div className="row g-3 g-sm-4">
        {/* Main Post */}
        <div className="col-lg-8">
          {selectedPost ? (
            <div>
              {/* One Main Image */}
              <div className="card-img mb-3 position-relative">
                {getMainImage(selectedPost) && (
                  <img
                    src={getMainImage(selectedPost)}
                    alt={selectedPost.title.rendered}
                    className="img-fluid w-100"
                  />
                )}
              </div>

              {/* Meta Info */}
              <div className="row g-3 align-items-center mb-2">
                <div className="col-auto d-flex align-items-center">
                  <i className="bi bi-person me-2"></i>
                  <span className="font-14 font-600 text-lite-gray">
                    {authors[selectedPost.author] || "SAMSA Author"}
                  </span>
                </div>
                <div className="col-auto d-flex align-items-center">
                  <i className="bi bi-gear me-2"></i>
                  <span className="font-14 font-600 text-lite-gray">
                        {selectedPost._embedded?.replies
                            ? `${selectedPost._embedded.replies[0].length} Comments`
                          : "No Comments"}
                    </span>
                </div>
              </div>

              {/* Title */}
              <h4
                className="title text-green-38B652 mt-3 mb-2 font-17 font-600 text-wrap"
                dangerouslySetInnerHTML={{
                  __html: selectedPost.title.rendered,
                }}
              />

              {/* Short Preview */}
              <p className="font-17 text-primary-color">
                {getPreviewContent(selectedPost.content.rendered)}
              </p>

              {/* Take Me Now Button */}
              <div className="mt-4">
                <a
                  href={selectedPost.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-success px-4 py-2 font-17 font-600"
                >
                  Click to View More
                </a>
              </div>
            </div>
          ) : (
            <div>Loading latest news...</div>
          )}
        </div>

        {/* Sidebar */}
        <div className="col-lg-4">
          {/* Search */}
          <div className="bg-gray-d9 p-4 mb-4">
            <h3 className="sideline-title font-23 font-700 mb-3">Search here</h3>
            <input
              type="text"
              className="form-control height-45 font-17"
              placeholder="search here..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {/* Recent News */}
          <div className="bg-gray-d9 p-4">
            <h3 className="sideline-title font-23 font-700 mb-3">Recent News</h3>
            <div className="row g-3 g-sm-4">
              {filteredPosts.map((post) => (
                <div
                  className="col-md-12 col-sm-6"
                  key={post.id}
                  onClick={() => handlePostClick(post)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="row g-3">
                    <div className="col-auto">
                      {post._embedded?.["wp:featuredmedia"]?.[0]?.source_url ? (
                        <img
                          src={post._embedded["wp:featuredmedia"][0].source_url}
                          alt={post.title.rendered}
                          className="img-fluid"
                          style={{
                            width: "80px",
                            height: "80px",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <div className=""></div>
                      )}
                    </div>
                    <div className="col text-primary-color">
                      <h4 className="font-17 font-700 mb-1 d-flex align-items-center">
                        <i className="icon-calender me-1"></i>
                        <span className="font-700 mt-1">
                          {new Date(post.date).toLocaleDateString()}
                        </span>
                      </h4>
                      <p
                        className="font-17 mb-0 lineHeight-20"
                        dangerouslySetInnerHTML={{
                          __html: post.title.rendered,
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
              {filteredPosts.length === 0 && (
                <p className="font-17 text-center text-muted">
                  No results found
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LatestNews;
